// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header__title[data-v-1cc6fa42]{font-size:27.2px;font-weight:700;border-bottom:3px solid #f4f5fd}.no-message__title[data-v-1cc6fa42]{font-size:19px;font-weight:700}.no-message__body[data-v-1cc6fa42]{font-size:15.2px;color:#7a7b97}", ""]);
// Exports
module.exports = exports;
